module.exports = __webpack_public_path__ + "79e2407c8fbc89990b5a6bf473f1cc55.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/social-media-icons/twitter.png
// module id = 3003
// module chunks = 0